import { Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-ikp-no-content',
  standalone: true,
  imports: [NgOptimizedImage, TranslatePipe],
  templateUrl: './no-content.component.html',
})
export class NoContentComponent {
  cardTitle = input<string>('global.noContent.title');
}
